<!-- components/ExperienceReferences.vue -->

<template>
  <b-card title="Experience and References">
    <b-form-group label="Years of Experience" label-for="years-of-experience">
      <b-form-input
        id="years-of-experience"
        v-model="experienceReferences.yearsOfExperience"
        type="number"
        min="0"
        :state="validateField('yearsOfExperience')"
      />
    </b-form-group>

    <b-form-group label="Major Clients / Projects">
      <b-form-textarea
        v-model="experienceReferences.majorClients"
        rows="3"
        placeholder="List key clients or projects"
      />
    </b-form-group>

    <b-form-group label="Reference Contact Name">
      <b-form-input
        v-model="experienceReferences.referenceName"
        :state="validateField('referenceName')"
      />
    </b-form-group>

    <b-form-group label="Reference Contact Email">
      <b-form-input
        v-model="experienceReferences.referenceEmail"
        type="email"
        :state="validateField('referenceEmail')"
      />
    </b-form-group>

    <b-form-group label="Reference Contact Phone">
      <b-form-input
        v-model="experienceReferences.referencePhone"
      />
    </b-form-group>

    <b-form-group label="Client Reference Letter">
      <b-form-file
        v-model="experienceReferences.referenceLetter"
        accept=".pdf,.doc,.docx"
      />
    </b-form-group>
  </b-card>
</template>

<script>
export default {
  name: 'ExperienceReferences',
  props: {
    value: Object,
    isSubmitted: Boolean,
  },
  data() {
    return {
      experienceReferences: this.value || {},
    }
  },
  methods: {
    validateField(fieldName) {
      if (!this.isSubmitted) return null
      return this.experienceReferences[fieldName] ? true : false
    },
  },
  watch: {
    experienceReferences: {
      handler(newValue) {
        this.$emit('input', newValue)
      },
      deep: true,
    },
  },
}
</script>
